/* heon-journal.js: Journal guides (content team, 2026-09-29). Loaded with defer, only by
   sections/heon-journal-guide.liquid (templates/article.guide.json).
   1. Reading progress (the gold hairline) and "In this guide" (marks the section being read, smooth jump).
   2. The interactive guide pieces. Each one is plain HTML in the article (a table or a list, translated with the
      article) that stays as it is when this script does not run; here it becomes:
        <heon-karat>      karat meter: 10K / 14K / 18K / 24K on a dial of 24 marks, stamp and pure-gold share
        <heon-stamp>      where the 585 stamp sits (clasp, ring, pendant) under a loupe that follows the mouse
        <heon-checklist>  "is it real gold" steps with Passed / Failed / Not sure and an honest summary
        <heon-chain-cut>  solid / semi-hollow / hollow: one link cut through, the core opening and closing
        <heon-length>     necklace lengths drawn on a neckline, with inches and centimeters
        <heon-clover>     the four leaves of the clover and what each one stands for
        <heon-stack>      layering recipes drawn on the neckline, every chain in its own texture, with the spacing
        <heon-steps>      a step-by-step card (cleaning) with a kitchen timer on the soaking step
        <heon-picker>     gift ideas by the person they are for, as tabs with small line drawings
        <heon-months>     the twelve birthstones on a wheel, opening on the current month
      and four generic pieces any story can use (2026-10-30, docs: heon-journal-engine/docs/COMPONENTS.md):
        <heon-quiz>       a short multiple-choice quiz that ends on one result with a link
        <heon-flip>       a grid of cards that turn over: term on the front, meaning on the back
        <heon-compare>    "A vs B (vs C)": pick an option to bring its column of the table forward
        <heon-timeline>   dated events on a line that scrolls (and swipes) sideways
   Choices are real radio groups or tabs (arrow keys, Home, End), results are announced politely, and nothing moves
   for readers who ask for reduced motion. The words the script writes come from the page (#hj-i18n, see
   snippets/heon-journal-t.liquid), English otherwise. */
(function () {
  'use strict';
  if (window.__hjGuide) return;
  window.__hjGuide = true;

  var D = document;
  var I = {};
  try {
    var src = D.getElementById('hj-i18n');
    if (src) I = JSON.parse(src.textContent) || {};
  } catch (e) { I = {}; }
  function T(k, d, v) {
    var s = typeof I[k] === 'string' && I[k] ? I[k] : d;
    if (v) Object.keys(v).forEach(function (x) { s = s.split('[' + x + ']').join(String(v[x])); });
    return s;
  }
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function still() { return !!(RM && RM.matches); }
  var seq = 0;
  function uid(p) { seq += 1; return 'hj-' + p + '-' + seq; }

  /* small DOM helpers */
  var NS = 'http://www.w3.org/2000/svg';
  var XL = 'http://www.w3.org/1999/xlink';
  function attrs(e, a) {
    if (!a) return e;
    Object.keys(a).forEach(function (k) {
      var v = a[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'text') e.textContent = v;
      else if (k === 'html') e.innerHTML = v;
      else e.setAttribute(k, v === true ? '' : String(v));
    });
    return e;
  }
  function kids(e, c) {
    if (c === null || c === undefined) return e;
    (Array.isArray(c) ? c : [c]).forEach(function (x) {
      if (x === null || x === undefined || x === false) return;
      if (Array.isArray(x)) kids(e, x);
      else e.appendChild(typeof x === 'string' ? D.createTextNode(x) : x);
    });
    return e;
  }
  function h(tag, a, c) { return kids(attrs(D.createElement(tag), a), c); }
  function s(tag, a, c) { return kids(attrs(D.createElementNS(NS, tag), a), c); }
  function arr(list) { return Array.prototype.slice.call(list || []); }
  function text(e) { return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function bare(td) {   // a table cell without the label that stacked tables show on phones (<span class="hp-tl">)
    var c = td.cloneNode(true);
    arr(c.querySelectorAll('.hp-tl')).forEach(function (x) { x.parentNode.removeChild(x); });
    return c;
  }
  function cellText(td) { return td ? text(bare(td)) : ''; }
  function cellHTML(td) { return td ? bare(td).innerHTML.trim() : ''; }
  function head(li) {   // "<strong>Faith:</strong> text" -> { name: 'Faith', html: 'text' }
    var st = li.querySelector('strong,b');
    var c = li.cloneNode(true);
    var s2 = c.querySelector('strong,b');
    if (s2) s2.parentNode.removeChild(s2);
    return { name: text(st).replace(/[\s:.–—-]+$/, ''), html: c.innerHTML.replace(/^\s*[:–—-]\s*/, '').trim() };
  }
  function tableRows(table) {
    var heads = arr(table.querySelectorAll('thead th')).map(text);
    return arr(table.querySelectorAll('tbody tr')).map(function (tr) {
      var c = arr(tr.children);
      return {
        tr: tr,
        name: cellText(c[0]),
        cells: c.slice(1).map(function (td, i) { return { label: heads[i + 1] || '', html: cellHTML(td), text: cellText(td) }; })
      };
    });
  }
  function dl(cells) {
    var d = h('dl', { class: 'hj-dl' });
    cells.forEach(function (c) {
      if (!c.html) return;
      d.appendChild(h('dt', { text: c.label }));
      d.appendChild(h('dd', { html: c.html }));
    });
    return d;
  }
  function inView(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } });
    }, { threshold: 0.3 });
    io.observe(el);
  }
  function setHref(u, id) {
    u.setAttribute('href', '#' + id);
    u.setAttributeNS(XL, 'xlink:href', '#' + id);
  }

  /* a row of choices: a radio group (role radio) or tabs (role tab); arrow keys move and choose, only the chosen one
     is in the Tab order */
  function choices(labels, o) {
    var tabs = o.role === 'tab';
    var flag = tabs ? 'aria-selected' : 'aria-checked';
    var g = h('div', { class: 'hj-seg', role: tabs ? 'tablist' : 'radiogroup', 'aria-label': o.label });
    var cur = -1;
    var bs = labels.map(function (l, i) {
      var b = h('button', { type: 'button', class: 'hj-opt', role: tabs ? 'tab' : 'radio', tabindex: '-1', id: uid('opt') }, l);
      b.setAttribute(flag, 'false');
      b.addEventListener('click', function () { pick(i, true); });
      g.appendChild(b);
      return b;
    });
    g.addEventListener('keydown', function (e) {
      var i = bs.indexOf(D.activeElement);
      if (i < 0) return;
      var j;
      switch (e.key) {
        case 'ArrowRight': case 'ArrowDown': j = (i + 1) % bs.length; break;
        case 'ArrowLeft': case 'ArrowUp': j = (i - 1 + bs.length) % bs.length; break;
        case 'Home': j = 0; break;
        case 'End': j = bs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      pick(j, true);
      bs[j].focus();
    });
    function pick(i, byUser) {
      if (i === cur) return;
      cur = i;
      bs.forEach(function (b, x) {
        b.setAttribute(flag, x === i ? 'true' : 'false');
        b.tabIndex = x === i ? 0 : -1;
      });
      o.onPick(i, !!byUser);
    }
    function clear() {   // nothing chosen; the first choice takes the Tab stop
      cur = -1;
      bs.forEach(function (b, x) { b.setAttribute(flag, 'false'); b.tabIndex = x === 0 ? 0 : -1; });
    }
    return { el: g, pick: pick, buttons: bs, clear: clear };
  }

  /* a guide piece: build(host) returns { node, keep, ready } or null (then the plain version stays) */
  function define(name, build) {
    if (!window.customElements || window.customElements.get(name)) return;
    window.customElements.define(name, class extends HTMLElement {
      connectedCallback() {
        if (this.__hj) return;
        this.__hj = true;
        var host = this;
        var plain = arr(host.children).filter(function (c) { return !c.classList.contains('hj-c-t'); });
        var ui = null;
        try { ui = build(host); } catch (err) { ui = null; if (window.console) console.warn('[heon-journal] ' + name, err); }
        if (!ui) return;
        if (ui.node) host.appendChild(ui.node);
        if (!ui.keep) plain.forEach(function (c) { c.hidden = true; });
        host.classList.add('is-on');
        if (ui.ready) ui.ready();
      }
    });
  }

  /* <heon-karat>: <table> rows <tr data-k="14" [data-heon]><th>14K</th><td>585</td><td>58.5%</td><td>note</td></tr> */
  define('heon-karat', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var heads = arr(table.querySelectorAll('thead th')).map(text);
    var rows = tableRows(table).map(function (r) {
      var k = parseInt(r.tr.getAttribute('data-k') || r.name, 10);
      return { k: k, name: r.name, stamp: r.cells[0] ? r.cells[0].text : '', pct: r.cells[1] ? r.cells[1].text : '', note: r.cells[2] ? r.cells[2].html : '', heon: r.tr.hasAttribute('data-heon') };
    }).filter(function (r) { return r.k > 0 && r.k <= 24; });
    if (rows.length < 2) return null;
    var start = 0;
    var want = parseInt(host.getAttribute('data-default'), 10);
    rows.forEach(function (r, i) { if (r.heon) start = i; });
    rows.forEach(function (r, i) { if (r.k === want) start = i; });

    var svg = s('svg', { viewBox: '0 0 200 200', 'aria-hidden': 'true', focusable: 'false' });
    var ticks = [];
    for (var i = 0; i < 24; i++) {
      var t = s('rect', { class: 'hj-ktick', x: 97, y: 5, width: 6, height: 30, rx: 1.5, transform: 'rotate(' + (i * 15) + ' 100 100)' });
      ticks.push(t);
      svg.appendChild(t);
    }
    var big = h('span', { class: 'hj-kbig' });
    var sub = h('span', { class: 'hj-ksub' });
    var dial = h('div', { class: 'hj-kdial', 'aria-hidden': 'true' }, [svg, h('div', { class: 'hj-kcenter' }, [big, sub])]);
    var dStamp = h('dd');
    var dPct = h('dd');
    var nums = h('dl', { class: 'hj-knums' }, [
      h('div', null, [h('dt', { text: heads[1] || '' }), dStamp]),
      h('div', null, [h('dt', { text: heads[2] || '' }), dPct])
    ]);
    var parts = h('p', { class: 'hj-sr' });
    var note = h('p', { class: 'hj-knote' });
    var badge = h('p', { class: 'hj-kbadge', hidden: true }, [h('span', { class: 'hj-opt-dot', 'aria-hidden': 'true' }), T('heon_uses', 'What Heon uses')]);
    var out = h('div', { class: 'hj-out', 'aria-live': 'polite' }, [nums, parts, note, badge]);

    var seen = false;
    var filled = 0;
    var chosen = rows[start];
    function fill(k) {
      var lo = Math.min(filled, k), hi = Math.max(filled, k), up = k >= filled;
      ticks.forEach(function (tk, x) {
        var d = 0;
        if (!still() && x >= lo && x < hi) d = (up ? x - filled : filled - 1 - x) * 16;
        tk.style.transitionDelay = d + 'ms';
        tk.classList.toggle('is-on', x < k);
      });
      filled = k;
    }
    function show(i) {
      var r = rows[i];
      chosen = r;
      // "14K" fits the dial; a longer name ("14 Karat", "14 carats") shows the number big and the word below
      var unit = r.name.length > 4 ? r.name.replace(/^\s*\d+\s*/, '') : '';
      big.textContent = unit ? String(r.k) : r.name;
      sub.textContent = (unit ? unit + ' · ' : '') + r.k + ' / 24';
      dStamp.textContent = r.stamp;
      dPct.textContent = r.pct;
      parts.textContent = T('karat_parts', '[k] of 24 parts pure gold', { k: r.k });
      note.innerHTML = r.note;
      badge.hidden = !r.heon;
      if (seen) fill(r.k);
    }
    var ch = choices(rows.map(function (r) {
      return r.heon ? [r.name, h('span', { class: 'hj-opt-dot', 'aria-hidden': 'true' })] : r.name;
    }), { label: T('karat_pick', 'Choose a karat'), onPick: show });
    var node = h('div', null, [ch.el, h('div', { class: 'hj-kui' }, [dial, out])]);
    return {
      node: node,
      ready: function () {
        ch.pick(start, false);
        inView(host, function () { seen = true; fill(chosen.k); });
      }
    };
  });

  /* <heon-stamp>: <ul><li data-spot="clasp|ring|pendant"><strong>Chains:</strong> where to look</li>...</ul> */
  var STAMP = {
    clasp: {
      at: [152, 121.5],
      art: function () {
        return [
          s('ellipse', { cx: 18, cy: 112, rx: 11, ry: 6.5 }),
          s('rect', { x: 26, y: 110, width: 18, height: 4, rx: 2 }),
          s('ellipse', { cx: 52, cy: 112, rx: 11, ry: 6.5 }),
          s('rect', { x: 60, y: 110, width: 18, height: 4, rx: 2 }),
          s('ellipse', { cx: 86, cy: 112, rx: 11, ry: 6.5 }),
          s('circle', { class: 'hj-g', cx: 104, cy: 112, r: 8 }),
          s('path', { class: 'hj-fg', d: 'M112 112C112 98 128 86 150 86C174 86 192 98 192 113C192 128 174 140 150 140C128 140 112 126 112 112Z' }),
          s('path', { d: 'M124 100C136 92 162 91 178 99' }),
          s('path', { d: 'M150 91v-7h8' }),
          s('rect', { class: 'hj-f', x: 138, y: 114.5, width: 28, height: 13, rx: 2.5 }),
          s('text', { x: 152, y: 124, 'text-anchor': 'middle' }, '585'),
          s('circle', { class: 'hj-g', cx: 200, cy: 113, r: 7 }),
          s('ellipse', { cx: 218, cy: 113, rx: 11, ry: 6.5 }),
          s('rect', { x: 226, y: 111, width: 14, height: 4, rx: 2 })
        ];
      }
    },
    ring: {
      at: [120, 81],
      art: function () {
        return [
          s('path', { class: 'hj-fg', d: 'M28 104A92 46 0 0 1 212 104L212 120A92 46 0 0 1 28 120Z' }),
          s('path', { d: 'M28 104A92 46 0 0 0 212 104' }),
          s('ellipse', { class: 'hj-hole', cx: 120, cy: 104, rx: 72, ry: 32 }),
          s('path', { class: 'hj-f', d: 'M48 104A72 32 0 0 1 192 104C170 86 70 86 48 104Z' }),
          s('text', { x: 120, y: 83.5, 'text-anchor': 'middle' }, '585')
        ];
      }
    },
    pendant: {
      at: [120, 151.5],
      art: function () {
        return [
          s('path', { class: 'hj-g', d: 'M6 20Q120 52 234 20', 'stroke-dasharray': '1.5 3.5' }),
          s('rect', { class: 'hj-fg', x: 110, y: 30, width: 20, height: 34, rx: 10 }),
          s('rect', { x: 115, y: 36, width: 10, height: 20, rx: 5 }),
          s('circle', { class: 'hj-fg', cx: 120, cy: 118, r: 56 }),
          s('circle', { class: 'hj-g', cx: 120, cy: 118, r: 49 }),
          s('text', { x: 120, y: 154, 'text-anchor': 'middle' }, '585')
        ];
      }
    }
  };
  define('heon-stamp', function (host) {
    var items = arr(host.querySelectorAll('li[data-spot]')).map(function (li) {
      var key = li.getAttribute('data-spot');
      if (!STAMP[key]) return null;
      var hd = head(li);
      return { key: key, name: hd.name || key, html: hd.html };
    }).filter(Boolean);
    if (!items.length) return null;
    var Z = 3.2, LX = 324, LY = 110, LR = 68;
    var ids = {};
    var clip = uid('clip');
    var defs = s('defs', null, s('clipPath', { id: clip }, s('circle', { cx: LX, cy: LY, r: LR })));
    items.forEach(function (it) {
      ids[it.key] = uid('art');
      defs.appendChild(s('g', { id: ids[it.key], class: 'hj-art' }, STAMP[it.key].art()));
    });
    var main = s('use', { class: 'hj-stamp-art' });
    var lens = s('use');
    var spot = s('circle', { class: 'hj-lens-spot', cx: 0, cy: 0, r: (LR / Z).toFixed(2) });
    var lead = s('line', { class: 'hj-lens-lead' });
    var svg = s('svg', { viewBox: '0 0 400 220', 'aria-hidden': 'true', focusable: 'false' }, [
      defs, main, lead, spot,
      s('g', { 'clip-path': 'url(#' + clip + ')' }, [s('circle', { class: 'hj-lens-bg', cx: LX, cy: LY, r: LR }), lens]),
      s('circle', { class: 'hj-lens-ring', cx: LX, cy: LY, r: LR })
    ]);
    var pos = [0, 0], raf = 0, cur = items[0], follow = false;
    function place(x, y) {
      pos = [x, y];
      lens.setAttribute('transform', 'translate(' + (LX - x * Z).toFixed(2) + ' ' + (LY - y * Z).toFixed(2) + ') scale(' + Z + ')');
      spot.setAttribute('transform', 'translate(' + x.toFixed(2) + ' ' + y.toFixed(2) + ')');
      lead.setAttribute('x1', (x + LR / Z).toFixed(2));
      lead.setAttribute('y1', y.toFixed(2));
      lead.setAttribute('x2', LX - LR);
      lead.setAttribute('y2', LY);
    }
    function glide(to) {
      window.cancelAnimationFrame(raf);
      if (still() || !window.requestAnimationFrame) { place(to[0], to[1]); return; }
      var from = pos.slice(), t0 = 0, dur = 560;
      raf = window.requestAnimationFrame(function step(now) {
        if (!t0) t0 = now;
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        place(from[0] + (to[0] - from[0]) * e, from[1] + (to[1] - from[1]) * e);
        if (k < 1) raf = window.requestAnimationFrame(step);
      });
    }
    var desc = h('div', { class: 'hj-stamp-desc' });
    var panel = h('div', { class: 'hj-stamp-stage', role: 'tabpanel', id: uid('stp'), tabindex: '0' }, [svg, desc]);
    var ch = choices(items.map(function (it) { return it.name; }), {
      role: 'tab',
      label: T('stamp_where', 'Where to look'),
      onPick: function (i, byUser) {
        cur = items[i];
        setHref(main, ids[cur.key]);
        setHref(lens, ids[cur.key]);
        desc.innerHTML = cur.html;
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
        if (byUser && !still() && main.animate) main.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, easing: 'ease-out' });
        if (byUser) glide(STAMP[cur.key].at);
        else place(STAMP[cur.key].at[0], STAMP[cur.key].at[1]);
      }
    });
    ch.buttons.forEach(function (b) { b.setAttribute('aria-controls', panel.id); });
    function home() { if (follow) { follow = false; glide(STAMP[cur.key].at); } }
    svg.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || !svg.getScreenCTM) return;
      var m = svg.getScreenCTM();
      if (!m) return;
      var pt = svg.createSVGPoint();
      pt.x = e.clientX;
      pt.y = e.clientY;
      pt = pt.matrixTransform(m.inverse());
      if (pt.x > 2 && pt.x < 246 && pt.y > 2 && pt.y < 218) {
        follow = true;
        window.cancelAnimationFrame(raf);
        place(pt.x, pt.y);
      } else home();
    });
    svg.addEventListener('pointerleave', home);
    var hint = h('p', { class: 'hj-hint', text: T('stamp_hint', 'Move across the piece to look closer') });
    return { node: h('div', null, [ch.el, panel, hint]), ready: function () { ch.pick(0, false); } };
  });

  /* <heon-checklist>: <ol><li><strong>Step.</strong> how</li>...</ol>; each step gets Passed / Failed / Not sure */
  var ICON = { pass: 'M2 6.5l2.6 2.6L10 3.5', fail: 'M3 3l6 6M9 3l-6 6', unsure: 'M4.3 4.4a1.8 1.8 0 1 1 2.5 1.7c-.5.2-.8.6-.8 1.1v.5M6 9.7v.1' };
  var WORD = { pass: 'Passed', fail: 'Failed', unsure: 'Not sure' };
  define('heon-checklist', function (host) {
    var ol = host.querySelector('ol');
    if (!ol) return null;
    var lis = arr(ol.children).filter(function (li) { return li.tagName === 'LI'; });
    if (!lis.length) return null;
    var base = uid('chk');
    var state = lis.map(function () { return null; });
    var inputs = [];
    var bar = h('span');
    var count = h('p', { class: 'hj-check-count' });
    var res = h('p', { class: 'hj-check-res' });
    var reset = h('button', { type: 'button', class: 'hj-reset', hidden: true, text: T('reset', 'Start over') });
    function update() {
      var done = state.filter(Boolean).length, tot = state.length;
      bar.style.transform = 'scaleX(' + (done / tot).toFixed(3) + ')';
      count.textContent = T('progress', '[n] of [t] checks answered', { n: done, t: tot });
      var r = '';
      if (state.indexOf('fail') > -1) r = T('res_fail', 'At least one check failed, so treat the piece as not solid gold until a jeweler tests it. Plated and filled pieces often pass some checks and fail others.');
      else if (done === tot && state.every(function (v) { return v === 'pass'; })) r = T('res_pass', 'Every check passed. That is a good sign, not proof: well-made plated and filled pieces can pass at-home checks too. For certainty, ask a jeweler for an acid or XRF test.');
      else if (done === tot) r = T('res_open', 'Some answers are still open. Finish the checks you can, then let a jeweler confirm with an acid or XRF test.');
      res.textContent = r;
      reset.hidden = done === 0;
    }
    lis.forEach(function (li, i) {
      var fs = h('fieldset', { class: 'hj-rate' }, h('legend', { class: 'hj-sr', text: T('step', 'Result for step [n]', { n: i + 1 }) }));
      ['pass', 'fail', 'unsure'].forEach(function (v) {
        var id = base + '-' + i + '-' + v;
        var inp = h('input', { type: 'radio', name: base + '-' + i, id: id, value: v });
        inp.addEventListener('change', function () { if (inp.checked) { state[i] = v; update(); } });
        var ic = s('svg', { viewBox: '0 0 12 12', 'aria-hidden': 'true', focusable: 'false' }, s('path', { d: ICON[v] }));
        fs.appendChild(inp);
        fs.appendChild(h('label', { for: id }, [ic, T(v, WORD[v])]));
        inputs.push(inp);
      });
      li.appendChild(fs);
    });
    reset.addEventListener('click', function () {
      inputs.forEach(function (x) { x.checked = false; });
      state = state.map(function () { return null; });
      update();
      if (inputs[0]) inputs[0].focus();
    });
    var foot = h('div', { class: 'hj-check-foot' }, [
      h('div', { class: 'hj-check-bar', 'aria-hidden': 'true' }, bar),
      h('div', { 'aria-live': 'polite' }, [count, res]),
      reset
    ]);
    update();
    return { node: foot, keep: true };
  });

  /* <heon-chain-cut>: <table> rows <tr data-core="0|0.45|0.8"><th>Solid</th><td>...</td>...</tr> */
  define('heon-chain-cut', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var rows = tableRows(table).map(function (r) {
      var c = parseFloat(r.tr.getAttribute('data-core'));
      r.core = isNaN(c) ? 0 : Math.max(0, Math.min(0.9, c));
      return r;
    });
    if (rows.length < 2) return null;
    var gid = uid('gold');
    var core = s('circle', { class: 'hj-cut-core', cx: 100, cy: 100, r: 84, fill: '#F4EDE3', stroke: '#8C6A33', 'stroke-width': 1, 'vector-effect': 'non-scaling-stroke' });
    var svg = s('svg', { viewBox: '0 0 200 200', 'aria-hidden': 'true', focusable: 'false' }, [
      s('defs', null, s('radialGradient', { id: gid, cx: '38%', cy: '32%', r: '78%' }, [
        s('stop', { offset: '0', 'stop-color': '#F3E2BC' }),
        s('stop', { offset: '.55', 'stop-color': '#D3AF6E' }),
        s('stop', { offset: '1', 'stop-color': '#A57D3E' })
      ])),
      s('circle', { cx: 100, cy: 100, r: 84, fill: 'url(#' + gid + ')', stroke: '#8C6A33', 'stroke-width': 1 }),
      core,
      s('path', { d: 'M46 62A66 66 0 0 1 92 36', fill: 'none', stroke: 'rgba(255,248,232,.7)', 'stroke-width': 2, 'stroke-linecap': 'round' })
    ]);
    core.style.transform = 'scale(0)';
    var wall = h('span', null, [h('i', { style: 'background:#C9A25F' }), h('span', { class: 'hj-cut-wall' })]);
    var hole = h('span', null, [h('i', { style: 'background:#F4EDE3;box-shadow:inset 0 0 0 1px #8C6A33' }), T('cut_core', 'Hollow core')]);
    var legend = h('p', { class: 'hj-cut-legend', 'aria-hidden': 'true' }, [wall, hole]);
    var title = h('p', { class: 'hj-out-t' });
    var body = h('div');
    var out = h('div', { class: 'hj-out', 'aria-live': 'polite' }, [title, body]);
    var ch = choices(rows.map(function (r) { return r.name; }), {
      label: T('cut_pick', 'Choose a construction'),
      onPick: function (i) {
        var r = rows[i];
        core.style.transform = 'scale(' + r.core + ')';
        wall.lastChild.textContent = r.core > 0 ? T('cut_wall', 'Gold wall') : T('cut_solid', 'Gold all the way through');
        hole.classList.toggle('is-off', !(r.core > 0));
        title.textContent = r.name;
        body.innerHTML = '';
        body.appendChild(dl(r.cells));
      }
    });
    var node = h('div', null, [ch.el, h('div', { class: 'hj-cut-ui' }, [h('div', { class: 'hj-cut-fig' }, [svg, legend]), out])]);
    return { node: node, ready: function () { ch.pick(0, false); } };
  });

  /* the neckline that <heon-length> and <heon-stack> draw on (viewBox 0 0 360 280): a chain of L inches (14 to 24)
     leaves the neck at x0/y0 and reaches its lowest point at 180/yb */
  function geo(L) {
    var a = Math.min(1, Math.max(0, (L - 14) / 2)), b = Math.max(0, L - 16);
    var x0 = 157 - a * 7 - b, y0 = 64 + a * 16 + b, yb = 90 + (L - 14) * 15.2;
    var d = yb - y0, sp = d * 0.12, x1 = 360 - x0;
    return {
      yb: yb,
      d: 'M' + x0 + ' ' + y0 + 'C' + (x0 - sp).toFixed(1) + ' ' + (y0 + d * 0.55).toFixed(1) + ' ' + (180 - d * 0.62).toFixed(1) + ' ' + yb.toFixed(1) + ' 180 ' + yb.toFixed(1) +
         'S' + (x1 + sp).toFixed(1) + ' ' + (y0 + d * 0.55).toFixed(1) + ' ' + x1 + ' ' + y0
    };
  }
  function neckFig() {
    return [
      s('path', { class: 'hj-fig-l', d: 'M158 0C158 30 157 56 154 78C150 94 128 102 96 108C60 114 30 128 16 158C10 172 8 200 8 280' }),
      s('path', { class: 'hj-fig-l', d: 'M202 0C202 30 203 56 206 78C210 94 232 102 264 108C300 114 330 128 344 158C350 172 352 200 352 280' }),
      s('path', { class: 'hj-fig-s', d: 'M170 124C150 128 124 120 100 126' }),
      s('path', { class: 'hj-fig-s', d: 'M190 124C210 128 236 120 260 126' }),
      s('path', { class: 'hj-fig-s', d: 'M172 119Q180 127 188 119' })
    ];
  }

  /* <heon-length>: <table> rows <tr data-in="18"><th>18 in (45.7 cm)</th><td>where it sits</td>...</tr> */
  define('heon-length', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var rows = tableRows(table).map(function (r) {
      r.inch = parseFloat(r.tr.getAttribute('data-in'));
      return r;
    }).filter(function (r) { return r.inch >= 12 && r.inch <= 36; });
    if (rows.length < 2) return null;
    var chains = rows.map(function (r) { var g = geo(r.inch); return s('path', { class: 'hj-chain', d: g.d }); });
    var dot = s('circle', { class: 'hj-chain-dot', cx: 0, cy: 0, r: 3.4 });
    var svg = s('svg', { viewBox: '0 0 360 280', 'aria-hidden': 'true', focusable: 'false' }, neckFig().concat(chains, [dot]));
    var title = h('p', { class: 'hj-out-t' });
    var body = h('div');
    var out = h('div', { class: 'hj-out', 'aria-live': 'polite' }, [title, body]);
    var start = 0;
    var want = parseFloat(host.getAttribute('data-default')) || 18;
    rows.forEach(function (r, i) { if (r.inch === want) start = i; });
    var ch = choices(rows.map(function (r) { return r.inch + '″'; }), {
      label: T('length_pick', 'Choose a length'),
      onPick: function (i, byUser) {
        var r = rows[i];
        chains.forEach(function (p, x) {
          p.classList.toggle('is-on', x === i);
          if (x === i) p.parentNode.appendChild(p);
        });
        svg.appendChild(dot);
        dot.setAttribute('transform', 'translate(180 ' + geo(r.inch).yb.toFixed(1) + ')');
        var p = chains[i];
        if (byUser && !still() && p.animate && p.getTotalLength) {
          var len = p.getTotalLength();
          p.style.strokeDasharray = len;
          var an = p.animate([{ strokeDashoffset: len }, { strokeDashoffset: 0 }], { duration: 700, easing: 'cubic-bezier(.2,.7,.2,1)' });
          an.onfinish = an.oncancel = function () { p.style.strokeDasharray = ''; };
        }
        title.textContent = r.name;
        body.innerHTML = '';
        body.appendChild(dl(r.cells));
      }
    });
    var node = h('div', null, [ch.el, h('div', { class: 'hj-len-stage' }, [svg, out])]);
    return { node: node, ready: function () { ch.pick(start, false); } };
  });

  /* <heon-clover>: <ul><li><strong>Faith</strong> what it stands for</li> x4</ul> */
  var LEAF = 'M0 0C-4 -8 -30 -18 -34 -42C-37 -60 -20 -70 -8 -62C-4 -59 -1 -55 0 -50C1 -55 4 -59 8 -62C20 -70 37 -60 34 -42C30 -18 4 -8 0 0Z';
  define('heon-clover', function (host) {
    var list = host.querySelector('ul,ol');
    if (!list) return null;
    var items = arr(list.children).filter(function (li) { return li.tagName === 'LI'; }).map(head).slice(0, 4);
    if (items.length < 4) return null;
    var leaves = [], groups = [];
    var svg = s('svg', { viewBox: '0 0 240 240', 'aria-hidden': 'true', focusable: 'false' }, [
      s('path', { class: 'hj-stem', d: 'M121 114C125 150 134 182 154 216' })
    ]);
    [-45, 45, 135, 225].forEach(function (rot, i) {
      var leaf = s('path', { class: 'hj-leaf', d: LEAF, 'vector-effect': 'non-scaling-stroke' });
      var g = s('g', { class: 'hj-leafg' }, s('g', { transform: 'translate(120 110) rotate(' + rot + ')' }, [
        leaf,
        s('path', { class: 'hj-leaf-v', d: 'M0 -5L0 -48' })
      ]));
      g.style.transitionDelay = (i * 110) + 'ms';
      leaf.addEventListener('click', function () { ch.pick(i, true); });
      leaves.push(leaf);
      groups.push(g);
      svg.appendChild(g);
    });
    svg.appendChild(s('circle', { cx: 120, cy: 110, r: 3, fill: '#B98F4C' }));
    var name = h('p', { class: 'hj-out-t' });
    var txt = h('div', { class: 'hj-clo-text' });
    var panel = h('div', { class: 'hj-out', role: 'tabpanel', id: uid('clo'), tabindex: '0' }, [name, txt]);
    var ch = choices(items.map(function (it) { return it.name; }), {
      role: 'tab',
      label: T('clover_pick', 'Choose a leaf'),
      onPick: function (i) {
        leaves.forEach(function (l, x) { l.classList.toggle('is-on', x === i); });
        name.textContent = items[i].name;
        txt.innerHTML = items[i].html;
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
      }
    });
    ch.buttons.forEach(function (b) { b.setAttribute('aria-controls', panel.id); });
    var fig = h('div', { class: 'hj-clo-fig' }, svg);
    var node = h('div', { class: 'hj-clo-ui' }, [fig, h('div', null, [ch.el, panel])]);
    return {
      node: node,
      ready: function () {
        ch.pick(0, false);
        if (still()) return;
        fig.classList.add('will-bloom');
        inView(host, function () { fig.classList.remove('will-bloom'); });
      }
    };
  });

  /* <heon-stack>: <table> rows <tr data-stack="16:cable,18:paperclip,20:rope"><th>Everyday trio</th>
     <td><ul><li>16 in ... cable</li>...</ul></td><td>why it works</td></tr>. ":p" after a chain hangs a pendant on it.
     The whole stack is drawn on the neckline, every chain in its own texture; the list in the row becomes the key. */
  var TEX = {
    cable: { w: 1.3 },
    paperclip: { w: 1.9, dash: '6.5 2.2', cap: 'round' },
    rope: { w: 3.4, dash: '2.1 1', cap: 'butt' },
    ball: { w: 3.1, dash: '0.01 4', cap: 'round' },
    popcorn: { w: 3.8, dash: '0.01 3', cap: 'round' },
    herringbone: { w: 4.4, sheen: true },
    belcher: { w: 2.6, dash: '3 1.9', cap: 'round' }
  };
  function strand(type, d) {
    var t = TEX[type] || TEX.cable;
    var g = s('g', { class: 'hj-strand' });
    g.appendChild(s('path', { d: d, 'stroke-width': t.w, 'stroke-dasharray': t.dash || null, 'stroke-linecap': t.cap || 'round' }));
    if (t.sheen) g.appendChild(s('path', { class: 'hj-sheen', d: d, 'stroke-width': 1 }));
    return g;
  }
  function inCm(x) { return Math.round(x * 2.54); }
  define('heon-stack', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var rows = tableRows(table).map(function (r) {
      r.chains = (r.tr.getAttribute('data-stack') || '').split(',').map(function (x) {
        var p = x.trim().split(':');
        return { L: parseFloat(p[0]), type: TEX[p[1]] ? p[1] : 'cable', pend: p[2] === 'p' };
      }).filter(function (c) { return c.L >= 14 && c.L <= 24; }).sort(function (a, b) { return a.L - b.L; });
      var cells = arr(r.tr.children).slice(1);
      r.keyAt = -1;
      cells.forEach(function (td, i) { if (r.keyAt < 0 && td.querySelector('ul,ol')) r.keyAt = i; });
      r.items = r.keyAt < 0 ? [] : arr(cells[r.keyAt].querySelectorAll('li')).map(function (li) { return li.innerHTML.trim(); });
      return r;
    }).filter(function (r) { return r.chains.length > 0; });
    if (rows.length < 2) return null;
    var layer = s('g');
    var svg = s('svg', { viewBox: '0 0 360 280', 'aria-hidden': 'true', focusable: 'false' }, neckFig().concat([layer]));
    var title = h('p', { class: 'hj-out-t' });
    var key = h('ul', { class: 'hj-stack-key' });
    var gap = h('p', { class: 'hj-stack-gap' });
    var body = h('div');
    var panel = h('div', { class: 'hj-out', role: 'tabpanel', id: uid('stk'), tabindex: '0' }, [title, key, gap, body]);
    var ch = choices(rows.map(function (r) { return r.name; }), {
      role: 'tab',
      label: T('stack_pick', 'Choose a stack'),
      onPick: function (i, byUser) {
        var r = rows[i];
        while (layer.firstChild) layer.removeChild(layer.firstChild);
        key.innerHTML = '';
        r.chains.forEach(function (c, x) {
          var g = geo(c.L);
          var st = strand(c.type, g.d);
          if (c.pend) {
            st.appendChild(s('g', { class: 'hj-pend', transform: 'translate(180 ' + g.yb.toFixed(1) + ')' }, [
              s('rect', { x: -1.8, y: -1.2, width: 3.6, height: 5.4, rx: 1.6 }),
              s('circle', { cx: 0, cy: 10, r: 6.2 })
            ]));
          }
          layer.appendChild(st);
          if (byUser && !still() && st.animate) {
            st.animate([{ opacity: 0, transform: 'translateY(-10px)' }, { opacity: 1, transform: 'none' }],
              { duration: 520, delay: x * 110, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
          }
          var sw = s('svg', { class: 'hj-stack-sw', viewBox: '0 0 44 14', 'aria-hidden': 'true', focusable: 'false' }, strand(c.type, 'M3 7H41'));
          var words = r.items[x] || (c.L + '″ (' + inCm(c.L) + ' cm)');
          key.appendChild(h('li', null, [sw, h('span', { html: words })]));
        });
        var gaps = [];
        for (var x = 1; x < r.chains.length; x++) gaps.push(r.chains[x].L - r.chains[x - 1].L);
        if (gaps.length) {
          var lo = Math.min.apply(null, gaps), hi = Math.max.apply(null, gaps);
          var n = lo === hi ? lo + '″ (' + inCm(lo) + ' cm)' : lo + '–' + hi + '″ (' + inCm(lo) + '–' + inCm(hi) + ' cm)';
          gap.textContent = T('stack_gap', 'Spacing: [n] between chains', { n: n });
          gap.hidden = false;
        } else gap.hidden = true;
        title.textContent = r.name;
        body.innerHTML = '';
        body.appendChild(dl(r.cells.filter(function (c, j) { return j !== r.keyAt; })));
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
      }
    });
    ch.buttons.forEach(function (b) { b.setAttribute('aria-controls', panel.id); });
    var node = h('div', null, [ch.el, h('div', { class: 'hj-len-stage hj-stack-stage' }, [svg, panel])]);
    return { node: node, ready: function () { ch.pick(0, false); } };
  });

  /* <heon-steps>: <ol><li [data-min="10"]><strong>Soak.</strong> how</li>...</ol>; one step at a time, and a kitchen
     timer on the step that has data-min (minutes) */
  define('heon-steps', function (host) {
    var ol = host.querySelector('ol');
    if (!ol) return null;
    var items = arr(ol.children).filter(function (li) { return li.tagName === 'LI'; }).map(function (li) {
      var hd = head(li);
      hd.min = parseFloat(li.getAttribute('data-min')) || 0;
      return hd;
    });
    var tot = items.length;
    if (tot < 2) return null;
    function two(n) { return (n < 10 ? '0' : '') + n; }
    var cur = 0;
    var bar = h('span');
    var count = h('p', { class: 'hj-steps-n' });
    var name = h('p', { class: 'hj-out-t' });
    var txt = h('div', { class: 'hj-steps-text' });
    var say = h('p', { class: 'hj-sr', 'aria-live': 'polite' });

    /* the timer */
    var tmin = 0, left = 0, total = 0, end = 0, iv = 0, state = 'idle';
    var R = 44, C = 2 * Math.PI * R;
    var ring = s('circle', { class: 'hj-timer-on', cx: 50, cy: 50, r: R, 'stroke-dasharray': C.toFixed(2), 'stroke-dashoffset': '0', transform: 'rotate(-90 50 50)' });
    var clock = h('span', { class: 'hj-timer-t' });
    var dial = h('div', { class: 'hj-timer-dial', 'aria-hidden': 'true' }, [
      s('svg', { viewBox: '0 0 100 100', focusable: 'false' }, [s('circle', { class: 'hj-timer-bg', cx: 50, cy: 50, r: R }), ring]),
      clock
    ]);
    var go = h('button', { type: 'button', class: 'hj-opt hj-timer-go' });
    var reset = h('button', { type: 'button', class: 'hj-reset', text: T('timer_reset', 'Reset') });
    var timer = h('div', { class: 'hj-timer', hidden: true }, [dial, h('div', { class: 'hj-timer-ctl' }, [go, reset])]);
    function paint() {
      var sec = Math.max(0, Math.ceil(left / 1000));
      clock.textContent = Math.floor(sec / 60) + ':' + two(sec % 60);
      ring.setAttribute('stroke-dashoffset', (C * (1 - left / total)).toFixed(2));
      go.textContent = state === 'run' ? T('timer_pause', 'Pause') : state === 'pause' ? T('timer_resume', 'Resume') : T('timer_start', 'Start a [n]-minute timer', { n: tmin });
      reset.hidden = state === 'idle';
      timer.classList.toggle('is-done', state === 'done');
    }
    function tick() {
      left = Math.max(0, end - Date.now());
      if (left <= 0) {
        window.clearInterval(iv);
        state = 'done';
        say.textContent = T('timer_done', 'Time is up. Lift the piece out and brush it gently.');
      }
      paint();
    }
    go.addEventListener('click', function () {
      if (state === 'run') { window.clearInterval(iv); left = Math.max(0, end - Date.now()); state = 'pause'; paint(); return; }
      if (state === 'done') { left = total; }
      end = Date.now() + left;
      state = 'run';
      say.textContent = '';
      window.clearInterval(iv);
      iv = window.setInterval(tick, 250);
      paint();
    });
    reset.addEventListener('click', function () {
      window.clearInterval(iv);
      state = 'idle';
      left = total;
      say.textContent = '';
      paint();
      go.focus();
    });

    var panel = h('div', { class: 'hj-steps-card', role: 'tabpanel', id: uid('stp'), tabindex: '0' }, [count, name, txt, timer]);
    var prev = h('button', { type: 'button', class: 'hj-reset hj-steps-prev', text: '← ' + T('step_prev', 'Previous') });
    var next = h('button', { type: 'button', class: 'hj-opt hj-steps-next' });
    var ch = choices(items.map(function (it, i) {
      return [h('span', { text: two(i + 1) }), h('span', { class: 'hj-sr', text: ' ' + it.name })];
    }), {
      role: 'tab',
      label: T('steps_pick', 'Steps'),
      onPick: function (i, byUser) {
        cur = i;
        var it = items[i];
        count.textContent = T('step_of', 'Step [n] of [t]', { n: i + 1, t: tot });
        name.textContent = it.name;
        txt.innerHTML = it.html;
        bar.style.transform = 'scaleX(' + ((i + 1) / tot).toFixed(3) + ')';
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
        ch.buttons.forEach(function (b, x) { b.classList.toggle('is-past', x < i); });
        if (it.min > 0) {
          if (tmin !== it.min) { tmin = it.min; total = left = it.min * 60000; state = 'idle'; }
          timer.hidden = false;
          paint();
        } else timer.hidden = true;
        prev.hidden = i === 0;
        next.hidden = i === tot - 1;
        next.textContent = T('step_next', 'Next step') + ' →';
        if (byUser && !still() && panel.animate) panel.animate([{ opacity: 0, transform: 'translateX(12px)' }, { opacity: 1, transform: 'none' }], { duration: 360, easing: 'ease-out' });
      }
    });
    ch.buttons.forEach(function (b) { b.setAttribute('aria-controls', panel.id); });
    prev.addEventListener('click', function () { if (cur > 0) ch.pick(cur - 1, true); });
    next.addEventListener('click', function () { if (cur < tot - 1) ch.pick(cur + 1, true); });
    var node = h('div', { class: 'hj-steps' }, [
      h('div', { class: 'hj-steps-bar', 'aria-hidden': 'true' }, bar),
      ch.el, panel,
      h('div', { class: 'hj-steps-nav' }, [prev, next]),
      say
    ]);
    return { node: node, ready: function () { ch.pick(0, false); } };
  });

  /* <heon-picker>: <ul><li data-ic="heart"><strong>For the romantic</strong> ideas, with links</li>...</ul>;
     tabs, each with a small line drawing (minimal, symbol, stone, heart, chain, hoop) */
  var PICK = {
    minimal: ['M12 5a7 7 0 1 0 0 14a7 7 0 1 0 0-14Z'],
    symbol: ['M12 3.5l1.9 6.6 6.6 1.9-6.6 1.9L12 20.5l-1.9-6.6L3.5 12l6.6-1.9Z'],
    stone: ['M7.5 5h9l3.5 4.5L12 20 4 9.5Z', 'M4 9.5h16', 'M12 20 9.5 9.5 11 5M12 20l2.5-10.5L13 5'],
    heart: ['M12 19.5s-7.5-4.6-7.5-10.2A4.2 4.2 0 0 1 12 7a4.2 4.2 0 0 1 7.5 2.3c0 5.6-7.5 10.2-7.5 10.2Z'],
    chain: ['M9.5 8.5h-2a3.5 3.5 0 0 0 0 7h2', 'M14.5 8.5h2a3.5 3.5 0 0 1 0 7h-2', 'M8.5 12h7'],
    hoop: ['M12 8a6 6 0 1 0 0 12a6 6 0 1 0 0-12Z', 'M12 8V3.5a1.6 1.6 0 0 1 2.9-.9']
  };
  function pic(key, cls) {
    return s('svg', { class: cls, viewBox: '0 0 24 24', 'aria-hidden': 'true', focusable: 'false' },
      (PICK[key] || PICK.minimal).map(function (d) { return s('path', { d: d }); }));
  }
  define('heon-picker', function (host) {
    var list = host.querySelector('ul,ol');
    if (!list) return null;
    var items = arr(list.children).filter(function (li) { return li.tagName === 'LI'; }).map(function (li) {
      var hd = head(li);
      hd.ic = li.getAttribute('data-ic') || 'minimal';
      return hd;
    });
    if (items.length < 2) return null;
    var art = h('div', { class: 'hj-pick-art' });
    var name = h('p', { class: 'hj-out-t' });
    var txt = h('div', { class: 'hj-pick-text' });
    var panel = h('div', { class: 'hj-pick-panel', role: 'tabpanel', id: uid('pck'), tabindex: '0' }, [art, h('div', { class: 'hj-out' }, [name, txt])]);
    var ch = choices(items.map(function (it) { return [pic(it.ic, 'hj-pick-ic'), it.name]; }), {
      role: 'tab',
      label: T('gift_pick', 'Who is it for?'),
      onPick: function (i, byUser) {
        var it = items[i];
        art.innerHTML = '';
        art.appendChild(pic(it.ic, 'hj-pick-big'));
        name.textContent = it.name;
        txt.innerHTML = it.html;
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
        if (byUser && !still() && panel.animate) panel.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, easing: 'ease-out' });
      }
    });
    ch.buttons.forEach(function (b) { b.setAttribute('aria-controls', panel.id); });
    return { node: h('div', null, [ch.el, panel]), ready: function () { ch.pick(0, false); } };
  });

  /* <heon-months>: a 12-row <table>, <tr data-m="1" data-sw="#7B1E2B[,#…]"><th>January</th><td>Garnet</td>...</tr>;
     a wheel of twelve stones with month tabs; it opens on the reader's current month */
  function slices(cols, r) {
    if (cols.length < 2) return [s('circle', { cx: 0, cy: 0, r: r, fill: cols[0] })];
    return cols.map(function (c, i) {
      var a0 = -Math.PI / 2 + i * 2 * Math.PI / cols.length, a1 = a0 + 2 * Math.PI / cols.length;
      return s('path', {
        fill: c,
        d: 'M0 0L' + (r * Math.cos(a0)).toFixed(2) + ' ' + (r * Math.sin(a0)).toFixed(2) + 'A' + r + ' ' + r + ' 0 0 1 ' + (r * Math.cos(a1)).toFixed(2) + ' ' + (r * Math.sin(a1)).toFixed(2) + 'Z'
      });
    });
  }
  function octa(r) {
    var p = [];
    for (var i = 0; i < 8; i++) { var a = (22.5 + i * 45) * Math.PI / 180; p.push([r * Math.cos(a), r * Math.sin(a)]); }
    return p;
  }
  function poly(p) { return 'M' + p.map(function (q) { return q[0].toFixed(2) + ' ' + q[1].toFixed(2); }).join('L') + 'Z'; }
  define('heon-months', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var rows = tableRows(table).map(function (r) {
      r.m = parseInt(r.tr.getAttribute('data-m'), 10);
      r.sw = (r.tr.getAttribute('data-sw') || '').split(',').map(function (c) { return c.trim(); }).filter(function (c) { return /^#[0-9a-f]{3,8}$/i.test(c); });
      return r;
    }).filter(function (r) { return r.m >= 1 && r.m <= 12 && r.sw.length; });
    if (rows.length < 6) return null;
    var lang = D.documentElement.getAttribute('lang') || 'en';
    function short(r) {
      var m;
      try { m = new Intl.DateTimeFormat(lang, { month: 'short' }).format(new Date(2024, r.m - 1, 15)).replace(/\.$/, ''); }
      catch (e) { m = r.name.slice(0, 3); }
      return m.charAt(0).toUpperCase() + m.slice(1);
    }
    var gid = uid('gem');
    var grad = s('linearGradient', { id: gid, x1: '0', y1: '0', x2: '1', y2: '1' });
    var shine = uid('shine');
    var wheel = s('g');
    var rings = [];
    var gems = rows.map(function (r, i) {
      var a = (-90 + i * (360 / rows.length)) * Math.PI / 180;
      var x = 120 + 92 * Math.cos(a), y = 120 + 92 * Math.sin(a);
      var lx = 120 + 64 * Math.cos(a), ly = 120 + 64 * Math.sin(a);
      var ring = s('circle', { class: 'hj-gem-ring', cx: 0, cy: 0, r: 17 });
      rings.push(ring);
      var g = s('g', { class: 'hj-gem', transform: 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ')' },
        [ring].concat(slices(r.sw, 12), [
          s('circle', { cx: 0, cy: 0, r: 12, fill: 'url(#' + shine + ')' }),
          s('circle', { class: 'hj-gem-edge', cx: 0, cy: 0, r: 12 })
        ]));
      g.addEventListener('click', function () { ch.pick(i, true); });
      wheel.appendChild(g);
      wheel.appendChild(s('text', { class: 'hj-gem-m', x: lx.toFixed(1), y: (ly + 3).toFixed(1), 'text-anchor': 'middle' }, short(r)));
      return g;
    });
    var O = octa(40), In = octa(22);
    var big = s('g', { class: 'hj-gem-big', transform: 'translate(120 120)' }, [
      s('path', { d: poly(O), fill: 'url(#' + gid + ')' }),
      s('path', { d: poly(O), fill: 'url(#' + shine + ')' }),
      s('path', { class: 'hj-facet', d: poly(In) }),
      s('path', { class: 'hj-facet', d: O.map(function (q, i) { return 'M' + q[0].toFixed(2) + ' ' + q[1].toFixed(2) + 'L' + In[i][0].toFixed(2) + ' ' + In[i][1].toFixed(2); }).join('') }),
      s('path', { class: 'hj-gem-edge', d: poly(O) })
    ]);
    var svg = s('svg', { viewBox: '0 0 240 240', 'aria-hidden': 'true', focusable: 'false' }, [
      s('defs', null, [grad, s('radialGradient', { id: shine, cx: '32%', cy: '28%', r: '75%' }, [
        s('stop', { offset: '0', 'stop-color': '#fff', 'stop-opacity': '.75' }),
        s('stop', { offset: '.45', 'stop-color': '#fff', 'stop-opacity': '.12' }),
        s('stop', { offset: '1', 'stop-color': '#000', 'stop-opacity': '.14' })
      ])]),
      s('circle', { class: 'hj-wheel', cx: 120, cy: 120, r: 92 }),
      wheel, big
    ]);
    var now = new Date().getMonth() + 1, start = 0;
    rows.forEach(function (r, i) { if (r.m === now) start = i; });
    var title = h('p', { class: 'hj-out-t' });
    var sws = h('p', { class: 'hj-sw', 'aria-hidden': 'true' });
    var badge = h('p', { class: 'hj-kbadge', hidden: true }, [h('span', { class: 'hj-opt-dot', 'aria-hidden': 'true' }), T('this_month', 'This month')]);
    var body = h('div');
    var panel = h('div', { class: 'hj-out', role: 'tabpanel', id: uid('mon'), tabindex: '0' }, [title, sws, body, badge]);
    var ch = choices(rows.map(short), {
      role: 'tab',
      label: T('month_pick', 'Choose a month'),
      onPick: function (i, byUser) {
        var r = rows[i];
        rings.forEach(function (x, j) { x.parentNode.classList.toggle('is-on', j === i); });
        while (grad.firstChild) grad.removeChild(grad.firstChild);
        var n = r.sw.length;
        r.sw.forEach(function (c, j) {
          grad.appendChild(s('stop', { offset: (j / n).toFixed(3), 'stop-color': c }));
          grad.appendChild(s('stop', { offset: ((j + 1) / n).toFixed(3), 'stop-color': c }));
        });
        if (byUser && !still() && big.animate) big.animate([{ opacity: 0.2, transform: 'translate(120px,120px) scale(.86) rotate(-22.5deg)' }, { opacity: 1, transform: 'translate(120px,120px) scale(1) rotate(0)' }], { duration: 520, easing: 'cubic-bezier(.2,.7,.2,1)' });
        title.textContent = r.name + ' · ' + (r.cells[0] ? r.cells[0].text : '');
        sws.innerHTML = '';
        r.sw.forEach(function (c) { sws.appendChild(h('span', { style: 'background:' + c })); });
        body.innerHTML = '';
        body.appendChild(dl(r.cells.slice(1)));
        badge.hidden = r.m !== now;
        panel.setAttribute('aria-labelledby', ch.buttons[i].id);
      }
    });
    ch.buttons.forEach(function (b, i) { b.setAttribute('aria-controls', panel.id); b.setAttribute('title', rows[i].name); });
    var node = h('div', null, [ch.el, h('div', { class: 'hj-mon-ui' }, [h('div', { class: 'hj-mon-fig' }, svg), panel])]);
    return { node: node, ready: function () { ch.pick(start, false); } };
  });

  /* ---- generic pieces (2026-10-30): any story can use these; markup in heon-journal-engine/docs/COMPONENTS.md ---- */

  /* the child of host that holds el (to place a control right before a table that may sit in a wrapper) */
  function topOf(host, el) {
    while (el && el.parentNode !== host) el = el.parentNode;
    return el;
  }

  /* <heon-quiz>: <ol> one <li> per question: <p><strong>Question?</strong></p><ul><li data-r="key">answer</li>...</ul></li>,
     then one <div data-result="key"> per result: <p class="hj-quiz-t">Title</p><p>text</p>
     <p class="hj-quiz-cta"><a href="...">Shop ...</a></p></div>. data-r may name several keys ("cable rope"): each gets a
     point; the most points wins, a tie goes to the result written first. One question at a time; a tap moves on. */
  define('heon-quiz', function (host) {
    var ol = host.querySelector('ol');
    var rs = arr(host.querySelectorAll('[data-result]'));
    if (!ol || rs.length < 2) return null;
    var keys = rs.map(function (r) { return r.getAttribute('data-result'); });
    var qs = arr(ol.children).filter(function (li) { return li.tagName === 'LI'; }).map(function (li) {
      var c = li.cloneNode(true);
      arr(c.querySelectorAll('ul,ol')).forEach(function (x) { x.parentNode.removeChild(x); });
      return {
        q: text(c),
        opts: arr(li.querySelectorAll('li[data-r]')).map(function (o) {
          return { t: text(o), k: (o.getAttribute('data-r') || '').split(/[\s,]+/).filter(function (k) { return keys.indexOf(k) > -1; }) };
        })
      };
    }).filter(function (q) { return q.q && q.opts.length > 1; });
    var tot = qs.length;
    if (!tot) return null;
    var cur = 0, adv = 0, ans = qs.map(function () { return -1; });
    var bar = h('span');
    var count = h('p', { class: 'hj-steps-n' });
    var steps = qs.map(function (q, i) {
      var tid = uid('qq');
      var title = h('p', { class: 'hj-out-t', id: tid, tabindex: '-1', text: q.q });
      var ch = choices(q.opts.map(function (o) { return o.t; }), { label: q.q, onPick: function (j) { ans[i] = j; navs(); } });
      ch.el.removeAttribute('aria-label');
      ch.el.setAttribute('aria-labelledby', tid);
      ch.el.addEventListener('click', function (e) {   // a tap or a click moves on; the keyboard waits for "Next"
        if (!e.detail || i === tot - 1 || !e.target.closest('.hj-opt')) return;
        window.clearTimeout(adv);
        adv = window.setTimeout(function () { if (cur === i) go(i + 1, true); }, still() ? 0 : 320);
      });
      ch.clear();
      return { ch: ch, title: title, el: h('div', { class: 'hj-quiz-step', hidden: true }, [title, ch.el]) };
    });
    var back = h('button', { type: 'button', class: 'hj-reset hj-steps-prev', text: '← ' + T('quiz_back', 'Back') });
    var next = h('button', { type: 'button', class: 'hj-opt hj-steps-next' });
    var quiz = h('div', { class: 'hj-quiz-card' }, [count].concat(steps.map(function (x) { return x.el; })));
    var nav = h('div', { class: 'hj-steps-nav' }, [back, next]);
    var rT = h('p', { class: 'hj-out-t', tabindex: '-1' });
    var rBody = h('div', { class: 'hj-quiz-text' });
    var again = h('button', { type: 'button', class: 'hj-reset', text: T('reset', 'Start over') });
    var res = h('div', { class: 'hj-quiz-card hj-quiz-res', hidden: true }, [
      h('p', { class: 'hj-kbadge' }, [h('span', { class: 'hj-opt-dot', 'aria-hidden': 'true' }), T('quiz_res', 'Your match')]),
      rT, rBody, again
    ]);
    var live = h('div', { 'aria-live': 'polite' }, res);
    function navs() {
      back.hidden = cur === 0;
      next.textContent = cur === tot - 1 ? T('quiz_see', 'See my result') + ' →' : T('quiz_next', 'Next') + ' →';
      next.disabled = ans[cur] < 0;
    }
    function go(i, byUser) {
      cur = i;
      steps.forEach(function (x, j) { x.el.hidden = j !== i; });
      count.textContent = T('quiz_q', 'Question [n] of [t]', { n: i + 1, t: tot });
      bar.style.transform = 'scaleX(' + (i / tot).toFixed(3) + ')';
      navs();
      if (byUser) {
        if (!still() && steps[i].el.animate) steps[i].el.animate([{ opacity: 0, transform: 'translateX(12px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'ease-out' });
        steps[i].title.focus();
      }
    }
    function result() {
      var sc = keys.map(function () { return 0; });
      ans.forEach(function (j, i) { if (j > -1) qs[i].opts[j].k.forEach(function (k) { sc[keys.indexOf(k)] += 1; }); });
      var w = 0;
      sc.forEach(function (v, x) { if (v > sc[w]) w = x; });
      var r = rs[w].cloneNode(true);
      var t = r.querySelector('.hj-quiz-t') || r.querySelector('h3,h4,strong,b');
      rT.textContent = text(t);
      if (t) {
        var p = t.parentNode;
        p.removeChild(t);
        if (p !== r && !text(p)) p.parentNode.removeChild(p);
      }
      arr(r.querySelectorAll('[id]')).forEach(function (x) { x.removeAttribute('id'); });
      rBody.innerHTML = '';
      while (r.firstChild) rBody.appendChild(r.firstChild);
      arr(rBody.querySelectorAll('.hj-quiz-cta a')).forEach(function (a) { a.classList.add('hh-btn'); });
      bar.style.transform = 'scaleX(1)';
      quiz.hidden = nav.hidden = true;
      res.hidden = false;
      if (!still() && res.animate) res.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'ease-out' });
      rT.focus();
    }
    back.addEventListener('click', function () { if (cur > 0) go(cur - 1, true); });
    next.addEventListener('click', function () {
      if (ans[cur] < 0) return;
      if (cur < tot - 1) go(cur + 1, true); else result();
    });
    again.addEventListener('click', function () {
      ans = ans.map(function () { return -1; });
      steps.forEach(function (x) { x.ch.clear(); });
      res.hidden = true;
      quiz.hidden = nav.hidden = false;
      go(0, true);
    });
    var node = h('div', { class: 'hj-quiz' }, [h('div', { class: 'hj-steps-bar', 'aria-hidden': 'true' }, bar), quiz, nav, live]);
    return { node: node, ready: function () { go(0, false); } };
  });

  /* <heon-flip>: <dl><dt>Term</dt><dd>What it means</dd>...</dl>; cards that turn over, term on the front, meaning on the
     back. The first link in a <dd> shows under its card once it is turned. */
  define('heon-flip', function (host) {
    var d = host.querySelector('dl');
    if (!d) return null;
    var items = [], it = null;
    arr(d.querySelectorAll('dt,dd')).forEach(function (x) {
      if (x.closest('dl') !== d) return;
      if (x.tagName === 'DT') { it = { name: text(x), dd: [] }; items.push(it); }
      else if (it) it.dd.push(x);
    });
    items = items.filter(function (o) { return o.name && o.dd.length; });
    if (items.length < 2) return null;
    var say = h('p', { class: 'hj-sr', 'aria-live': 'polite' });
    var all = h('button', { type: 'button', class: 'hj-reset hj-flip-all' });
    var cards = items.map(function (o, i) {
      var mean = o.dd.map(text).join(' ');
      var link = null;
      o.dd.some(function (x) { link = x.querySelector('a[href]'); return !!link; });
      var b = h('button', { type: 'button', class: 'hj-flip-b', 'aria-expanded': 'false' }, h('span', { class: 'hj-flip-in' }, [
        h('span', { class: 'hj-flip-fr' }, [
          h('span', { class: 'hj-flip-n', 'aria-hidden': 'true', text: (i < 9 ? '0' : '') + (i + 1) }),
          h('span', { class: 'hj-flip-t', text: o.name }),
          h('span', { class: 'hj-flip-ic', 'aria-hidden': 'true' })
        ]),
        h('span', { class: 'hj-flip-bk' }, [h('span', { class: 'hj-flip-kt', text: o.name }), h('span', { class: 'hj-flip-m', text: mean })])
      ]));
      var li = h('li', { class: 'hj-flip-c' }, b);
      if (link) li.appendChild(h('a', { class: 'hj-flip-a', href: link.getAttribute('href'), text: text(link) + ' →' }));
      var c = {
        on: false,
        set: function (on, quiet) {
          c.on = on;
          li.classList.toggle('is-flip', on);
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (on && !quiet) say.textContent = o.name + ': ' + mean;
        },
        li: li
      };
      b.addEventListener('click', function () { c.set(!c.on); sync(); });
      return c;
    });
    function sync() {
      all.textContent = cards.every(function (c) { return c.on; }) ? T('flip_none', 'Hide all') : T('flip_all', 'Show all');
    }
    all.addEventListener('click', function () {
      var on = !cards.every(function (c) { return c.on; });
      cards.forEach(function (c) { c.set(on, true); });
      say.textContent = '';
      sync();
    });
    sync();
    var node = h('div', { class: 'hj-flip' }, [
      h('div', { class: 'hj-flip-head' }, [h('p', { class: 'hj-flip-hint', text: T('flip_hint', 'Tap a card to turn it over') }), all]),
      h('ul', { class: 'hj-flip-g', role: 'list' }, cards.map(function (c) { return c.li; })),
      say
    ]);
    return { node: node };
  });

  /* <heon-compare [data-default="2"]>: a <table>, options as column heads (<th scope="col" [data-heon]>), one row per
     point (<th scope="row">). A switcher over the table brings one option's column forward (on phones its value moves
     to the top of every row); the table itself stays. */
  define('heon-compare', function (host) {
    var table = host.querySelector('table');
    if (!table) return null;
    var hs = arr(table.querySelectorAll('thead th'));
    var rows = arr(table.querySelectorAll('tbody tr'));
    if (hs.length < 3 || !rows.length) return null;
    var opts = hs.slice(1).map(function (th) { return { name: text(th), heon: th.hasAttribute('data-heon') }; });
    var start = 0;
    opts.forEach(function (o, i) { if (o.heon) start = i; });
    var want = parseInt(host.getAttribute('data-default'), 10);
    if (want >= 1 && want <= opts.length) start = want - 1;
    var say = h('p', { class: 'hj-sr', 'aria-live': 'polite' });
    var ch = choices(opts.map(function (o) {
      return o.heon ? [o.name, h('span', { class: 'hj-opt-dot', 'aria-hidden': 'true' })] : o.name;
    }), {
      label: T('cmp_pick', 'Highlight an option'),
      onPick: function (i, byUser) {
        var col = i + 1;
        hs.forEach(function (th, x) { th.classList.toggle('is-hl', x === col); th.classList.toggle('is-dim', x > 0 && x !== col); });
        rows.forEach(function (tr) {
          arr(tr.children).forEach(function (c, x) {
            c.classList.toggle('is-hl', x === col);
            c.classList.toggle('is-dim', x > 0 && x !== col);
          });
        });
        if (byUser) say.textContent = T('cmp_on', 'Highlighted: [t]', { t: opts[i].name });
      }
    });
    table.classList.add('hj-cmp-t');
    host.insertBefore(ch.el, topOf(host, table));
    return { node: say, keep: true, ready: function () { ch.pick(start, false); } };
  });

  /* <heon-timeline>: <ol><li><strong>1924</strong> what happened</li>...</ol>; the list becomes a line of cards that
     scrolls sideways (snaps, swipes on phones), with Earlier / Later and a count. */
  define('heon-timeline', function (host) {
    var ol = host.querySelector('ol,ul');
    if (!ol) return null;
    var lis = arr(ol.children).filter(function (li) { return li.tagName === 'LI'; });
    if (lis.length < 2) return null;
    var cap = host.querySelector('.hj-c-t');
    ol.classList.add('hj-tl-list');
    lis.forEach(function (li) {
      var st = li.querySelector('strong,b');
      if (st && st.parentNode === li) st.classList.add('hj-tl-d');
    });
    var track = h('div', { class: 'hj-tl-track', tabindex: '0', role: 'region', 'aria-label': cap ? text(cap) : T('tl_label', 'Timeline') });
    ol.parentNode.insertBefore(track, ol);
    track.appendChild(ol);
    var prev = h('button', { type: 'button', class: 'hj-opt hj-tl-btn', 'aria-label': T('tl_prev', 'Earlier'), text: '←' });
    var next = h('button', { type: 'button', class: 'hj-opt hj-tl-btn', 'aria-label': T('tl_next', 'Later'), text: '→' });
    var count = h('p', { class: 'hj-tl-n', 'aria-hidden': 'true' });
    var bar = h('span');
    var nav = h('div', { class: 'hj-tl-nav' }, [prev, next, h('div', { class: 'hj-check-bar', 'aria-hidden': 'true' }, bar), count]);
    var ticking = false;
    function at() {   // the card nearest the start of the track
      var x = track.scrollLeft, best = 0, bd = Infinity;
      lis.forEach(function (li, i) { var dd = Math.abs(li.offsetLeft - ol.offsetLeft - x); if (dd < bd) { bd = dd; best = i; } });
      return best;
    }
    function frame() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var fits = max < 4;
      nav.hidden = fits;
      track.classList.toggle('is-more', !fits && track.scrollLeft < max - 4);
      if (fits) return;
      var i = track.scrollLeft >= max - 4 ? lis.length - 1 : at();
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft >= max - 4;
      count.textContent = (i + 1) + ' / ' + lis.length;
      bar.style.transform = 'scaleX(' + ((i + 1) / lis.length).toFixed(3) + ')';
    }
    function tick() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
    function step(dir) {
      var i = Math.max(0, Math.min(lis.length - 1, at() + dir));
      track.scrollTo({ left: lis[i].offsetLeft - ol.offsetLeft, behavior: still() ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    return { node: nav, keep: true, ready: frame };
  });

  /* 1. reading progress and "In this guide" */
  function page() {
    var art = D.querySelector('article.hj');
    if (!art) return;
    var prose = art.querySelector('.hj-body .hp-prose');
    var bar = D.querySelector('.hj-progress span');
    var links = arr(art.querySelectorAll('.hj-toc-a'));
    var heads = [];
    links.forEach(function (a) {
      var t = D.getElementById(decodeURIComponent((a.getAttribute('href') || '').slice(1)));
      if (t && heads.indexOf(t) < 0) heads.push(t);
    });
    var ticking = false, cur;
    function frame() {
      ticking = false;
      var vh = window.innerHeight || D.documentElement.clientHeight;
      if (prose && bar) {
        var r = prose.getBoundingClientRect();
        var p = (vh * 0.35 - r.top) / Math.max(1, r.height);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      }
      if (heads.length) {
        var line = vh * 0.3, now = null;
        for (var i = 0; i < heads.length; i++) {
          if (heads[i].getBoundingClientRect().top <= line) now = heads[i];
          else break;
        }
        if (now !== cur) {
          cur = now;
          links.forEach(function (a) {
            if (now && a.getAttribute('href') === '#' + now.id) a.setAttribute('aria-current', 'true');
            else a.removeAttribute('aria-current');
          });
        }
      }
    }
    function tick() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    frame();
    art.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.hj-toc-a') : null;
      if (!a) return;
      var t = D.getElementById(decodeURIComponent(a.hash.slice(1)));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
      if (window.history && history.pushState) history.pushState(null, '', a.hash);
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      try { t.focus({ preventScroll: true }); } catch (err) { /* older browsers: the scroll already happened */ }
    });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', page);
  else page();
})();
